import { apiFetch } from '../config/api'

export type ParameterLabelKey =
  | 'parameter1'
  | 'parameter2'
  | 'parameter3'
  | 'parameter4'
  | 'parameter5'
  | 'parameter6'
  | 'parameter7'
  | 'parameter8'
  | 'parameter9'
  | 'parameter10'
  | 'parameter11'
  | 'parameter12'
  | 'parameter13'

export type BevelParameterLabels = Partial<Record<ParameterLabelKey, string>>

export type BevelGeometryImageAdminItem = {
  id: number
  jointType: string
  parameter1: string
  parameter2: string
  parameter3: string
  parameter4: string
  parameter5: string
  parameter6: string
  parameter7: string
  parameter8: string
  parameter9: string
  parameter10: string
  parameter11: string
  parameter12: string
  parameter13: string
  extraData: string
  parameterLabels: BevelParameterLabels | null
  updatedAt: string
  signedImageUrl: string | null
  fileKey: string
  imageUrl: string
}

export type ResolvedBevelGeometry = {
  jointType: string
  imageUrl: string | null
  parameterLabels: BevelParameterLabels | null
  /**
   * The 13 parameter values from the matched admin row. Bevel Details renders
   * these read-only on the View geometry modal — there is no per-bevel editor
   * for parameter values anymore.
   */
  parameterValues: BevelParameterLabels | null
}

export type BevelGeometrySlotPayload = {
  jointType: string
  parameter1: string
  parameter2: string
  parameter3: string
  parameter4: string
  parameter5: string
  parameter6: string
  parameter7: string
  parameter8: string
  parameter9: string
  parameter10: string
  parameter11: string
  parameter12: string
  parameter13: string
  extraData?: string
}

export async function createBevelGeometryImageUploadUrl(params: {
  fileName: string
  contentType: string
}): Promise<{ uploadUrl: string; fileKey: string; publicUrl: string }> {
  return apiFetch('/api/bevel-geometry-images/upload-url', {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

export async function registerBevelGeometryImage(params: {
  jointType: string
  parameter1: string
  parameter2: string
  parameter3: string
  parameter4: string
  parameter5: string
  parameter6: string
  parameter7: string
  parameter8: string
  parameter9: string
  parameter10: string
  parameter11: string
  parameter12: string
  parameter13: string
  extraData?: string
  imageUrl: string
  fileKey: string
  parameterLabels?: BevelParameterLabels | null
}): Promise<{ id: number; lookupHash: string }> {
  return apiFetch('/api/bevel-geometry-images', {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

export async function resolveBevelGeometrySlots(
  slots: BevelGeometrySlotPayload[]
): Promise<{ results: ResolvedBevelGeometry[] }> {
  return apiFetch('/api/bevel-geometry-images/resolve', {
    method: 'POST',
    body: JSON.stringify({ slots })
  })
}

export async function listBevelGeometryImagesAdmin(params?: {
  limit?: number
  offset?: number
  jointType?: string
}): Promise<{ items: BevelGeometryImageAdminItem[]; total: number }> {
  const sp = new URLSearchParams()
  if (params?.limit != null) sp.set('limit', String(params.limit))
  if (params?.offset != null) sp.set('offset', String(params.offset))
  if (params?.jointType != null && params.jointType.trim() !== '') {
    sp.set('joint_type', params.jointType.trim())
  }
  const q = sp.toString()
  return apiFetch(`/api/bevel-geometry-images/admin-list${q ? `?${q}` : ''}`)
}

export async function deleteBevelGeometryImage(id: number): Promise<void> {
  await apiFetch(`/api/bevel-geometry-images/${id}`, { method: 'DELETE' })
}
